<template>
	<div class="publicbenact">
		<header-view :tabsign='8'></header-view>
		
		<div class="con_tent">
			<div class="concar w12 min-h">
				<div class="toptitle">
					<div class="left_c">
						<div class="redcon"></div>
						<span>公益活动</span>
					</div>
					<div class="right_c">
						<div class="searchcon">
							 <input class="inputa" :class="searchv?'':'plac'" @input="changeinput" v-model="searchv" placeholder="请输入"/>
							 <img class="imgcon" src="../../assets/newimg/searchimg.png" alt="" 
							 @click="changeinput"/>
						</div>
					</div>
				</div>
				
				<div>
					<div v-for="(item,index) in list" class="actsignle">
						<div class="l_con">
							<el-image fit='cover' :src="getFileAccessHttpUrl(item.breviaryMap)" :title="item.title" ></el-image>
						</div>
						<div class="r_con">
							<div class="title" :title="item.title">{{item.title || ''}}</div>
							<div class="details">{{gethypertext(item.content)}}</div>
							<div class="seebtn" @click="toDatail(index,item)">查看详情</div>
						</div>
					</div>
				</div>
							
			</div>
			
		</div>
		
		<zhini-pagination
		  class="zhini-pagination"
		  :currentPage="pageNo"
		  :totalPage="totalPage"
		  @pageNum="pageNum"
		></zhini-pagination>	
			
	</div>
	
</template>

<script>

import zhiniPagination from "../../components/zhini-pagination.vue";
export default {
  components: {
 	  zhiniPagination
  },
  data: function() {
		return {
			list: "",
			pageNo: 1,
			pageSize: 4,
			totalPage: 0,
			url: "",
			
			typesign:0,
			searchv:"",
		  
		};
				
  },
  
  methods: {
		//搜索
		changeinput(){
			this.pageNo=1
			this.init()  
		},
		
		//过滤富文本
		gethypertext(str){
			  if(str == null){
					return "";
			  }
			  var str = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "").replace(/&rdquo;/gi, "")
			              .replace(/&ldquo;/gi, "").replace(/\n/gi, "").replace(/&hellip;/gi, "").replace(/&mdash;/gi, "");
			  str = str.substring(0,100);
			  return str;
		},
		
		toDatail(indexsign,item){
			this.$router.push({ path: '/benefitactivitiesdetail', query: {index:indexsign,id:item.id} });
		},
		 
		init() {
		  var that = this;
		  var val = "sendTime"
		  if(this.$route.query.type == 2){
			  val = "views"
		  }
		  this.httpGet("web/info/list", {
				// sort:val,
				infoType:"0",
				pageNo: this.pageNo,
				pageSize: this.pageSize,
				title:this.searchv
		  }).then(res => {
				that.list = res.result.records;
				that.totalPage = Math.ceil(res.result.total / that.pageSize);
		  });
		},
		pageNum(e) {
		  window.pageYOffset = 0;
		  document.documentElement.scrollTop = 0;
		  document.body.scrollTop = 0;	
			
		  this.pageNo = e;
		  this.init();
		}
  },
  
  mounted() {
		this.init();
		window.pageYOffset = 0;
		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;
  }
  
};
</script>

<style scoped=" scoped" lang="scss">
	
.publicbenact{
	.con_tent{
		display: flex;
		justify-content: center;
	}
	.concar {
		background: #ffffff;
		margin-top: 100px;
		.toptitle{
			height: 60px;
			border-bottom: 1px solid #ededed;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.left_c{
				display: flex;
				align-items: center;
				.redcon{
					width: 5px;
					height: 20px;
					background: #E70012;
					margin-right:20px;
				}
				font-size:25px;
				font-weight: 400;
				color: #E61F26;
			}
			.right_c{
				.searchcon{
					height: 40px;
					line-height: 40px;
					width: 268px;
					border:1px solid #F1F1F1;
					border-radius:15px;
					padding-left: 20px;
					padding-right: 20px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.inputa{
						font-size: 14px;
						height: 100%;
					}
					.imgcon{
						height:18px;
						width: 18px;
					}
				}
			}
		}
		
		.actsignle{
			height: 360px;
			border: 1px solid #EEEEEE;
			margin-top: 20px;
			margin-bottom: 40px;
			display: flex;
			align-items: center;
			.l_con{
				width: 595px;
				.el-image{
					width: 595px;
					height: 360px;
				}
			}
			.r_con{
				flex: 1;
				height: 100%;
				padding-left: 60px;
				padding-right: 40px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				.title{
					font-size: 18px;
					font-weight: 400;
					color: #333333;
					margin-bottom: 60px;
				}
				.details{
					font-size:16px;
					font-weight: 400;
					color: #666666;
					margin-bottom: 40px;
				}
				.seebtn{
					cursor: pointer;
					width: 120px;
					height: 32px;
					line-height:32px;
					text-align: center;
					border-radius: 15px;
					border: 1px solid #E50112;
					font-size: 16px;
					font-weight: 400;
					color: #E50112;
				}
			}
		}
		
		
			
	}
	
		
	.zhini-pagination {
	    position: relative;
	    top:0px;
	    width: 100%;
	    left: 0px;
	}	
	
	
}

</style>
